import Http from '@/utils/http';
import axios from 'axios';
import i18n from '@/main';

const URL_BASE = '/operacao-cda-wa';

export default {
    aprovarOperacao(id) {
        return Http.post({
            url: URL_BASE + `/${id}/aprovar`,
            lockScreen: true
        });
    },

    reprovarOperacao(id) {
        return Http.post({
            url: URL_BASE + `/${id}/reprovar`,
            lockScreen: true
        });
    },

    buscarOperacoesEmCadastramento({ page, size, sort }) {
        return Http.get({
            url:
                URL_BASE +
                `/em-cadastramento?page=${page - 1}&size=${size}&sort=${sort}`,
            lockScreen: false
        });
    },

    validarPlanilha(planilha) {
        const url =
            process.env.VUE_APP_HTTP_PATH + URL_BASE + '/validar-planilha';

        const formData = new FormData();
        formData.append('file', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    processarPlanilha({ hash }) {
        return Http.post({
            url: `${URL_BASE}/${hash}/processar-planilha`,
            data: {},
            lockScreen: false
        });
    },

    cadastrarOperacoes() {
        return Http.get({
            url: URL_BASE + `/cadastrar`,
            lockScreen: false
        });
    },

    downloadPlanilhaModelo(arquivoHash) {
        const fileLink = document.createElement('a');
        try {
            return Http.get({
                url: URL_BASE + `/download-planilha`,
                responseType: 'blob',
                data: null,
                lockScreen: true,
                lockMessage: i18n.t(
                    'mensagens.sistema.preparandoDadosParaDownload'
                )
            }).then(response => {
                if (response.status === 200) {
                    const fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    fileLink.href = fileURL;
                    const filenameRegex = /filename=['"]?([^;\r\n"']*)['"]?;?/;
                    const contentDisposition =
                        response.headers['content-disposition'];

                    fileLink.setAttribute(
                        'download',
                        filenameRegex.exec(contentDisposition)[1]
                    );
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    return Promise.resolve();
                }
            });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    baixarPlanilhaComErros({ hash }) {
        const fileLink = document.createElement('a');
        try {
            return Http.get({
                url: URL_BASE + `/${hash}/download-planilha`,
                responseType: 'blob',
                data: null,
                lockScreen: false
            }).then(response => {
                if (response.status === 200) {
                    const fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    fileLink.href = fileURL;
                    const filenameRegex = /filename=['"]?([^;\r\n"']*)['"]?;?/;
                    const contentDisposition =
                        response.headers['content-disposition'];

                    fileLink.setAttribute(
                        'download',
                        filenameRegex.exec(contentDisposition)[1]
                    );
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    return Promise.resolve();
                }
            });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarOperacaoPorId(id) {
        return Http.get({
            url: URL_BASE + `/${id}`,
            lockScreen: false
        });
    },

    buscarCarsDaOperacao({ idOperacao, apenasInconformes, page, size, sort }) {
        const url =
            `/${idOperacao}/cars` +
            `?apenasInconformes=${apenasInconformes}` +
            `&page=${page - 1}&size=${size}&sort=${sort}`;

        return Http.get({
            url: URL_BASE + url,
            lockScreen: false
        });
    },

    removerCars(ids) {
        return Http.get({
            url: URL_BASE + `/remover-cars?idsComposicoes=${ids}`,
            lockScreen: false
        });
    },

    buscarDiagnosticoComposicao(id) {
        return Http.get({
            url: URL_BASE + `/composicao/${id}/diagnostico`,
            lockScreen: true
        });
    },

    exportarAnalisePdf(id) {
        const fileLink = document.createElement('a');
        try {
            return Http.get({
                url: URL_BASE + `/${id}/exportar-analise`,
                responseType: 'blob',
                lockScreen: true,
                lockMessage: i18n.t('mensagens.sistema.exportandoRelatorio')
            }).then(response => {
                if (response.status === 200) {
                    const fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    fileLink.href = fileURL;

                    const filenameRegex = /filename=['"]?([^;\r\n"']*)['"]?;?/;
                    const contentDisposition =
                        response.headers['content-disposition'];

                    fileLink.setAttribute(
                        'download',
                        filenameRegex.exec(contentDisposition)[1]
                    );
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    return Promise.resolve();
                }
            });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    exportarAnaliseExcel(id) {
        const fileLink = document.createElement('a');
        try {
            return Http
                .get({
                url: URL_BASE + `/${id}/exportar-analise-excel`,
                responseType: 'blob',
                lockScreen: true,
                lockMessage: 'Exportando relatório'
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarCulturas() {
        return Http.get({
            url: '/culturas-cda-wa',
            lockScreen: false
        });
    },

    buscarSafras() {
        return Http.get({
            url: '/safras-cda-wa',
            lockScreen: false
        });
    },

    buscarOperacoes(filtros, { page, size, sort }) {
        return Http.post({
            url: URL_BASE + `?page=${page - 1}&size=${size}&sort=${sort}`,
            data: filtros,
            lockScreen: false
        });
    },

    buscarStatusFiltro(status) {
        return Http.get({
            url: URL_BASE + '/status?status=' + encodeURIComponent(status),
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.filtrandoStatus')
        });
    },

    buscarTotalizadores(filtros) {
        return Http.post({
            url: URL_BASE + '/totalizadores',
            data: filtros,
            lockScreen: false
        });
    },

    buscarResumoPorId(idOperacao) {
        return Http.get({
            url: URL_BASE + `/${idOperacao}/resumo`,
            lockScreen: false
        });
    },

    limparCadastramento() {
        return Http.get({
            url: URL_BASE + '/limpar-cadastramento',
            lockScreen: false
        });
    },

    verificarSeIdentificadorEmUso(identificador) {
        return Http.get({
            url: URL_BASE + `/verificar-identificar-em-uso/${identificador}`,
            lockScreen: false
        });
    },

    editar(id, bodyAtualizacao) {
        return Http.post({
            url: URL_BASE + `/${id}`,
            data: bodyAtualizacao,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.atualizandoOperacao')
        });
    },

    buscarMonitoramentoOperacaoPorIdOperacao(id) {
        return Http.get({
            url: URL_BASE + `/${id}/monitoramento`,
            lockScreen: false
        });
    },

    buscarOperacoesInibicao(payload, lockScreen = false) {
        return Http.post({
            url: URL_BASE + '/operacoes-inibicao',
            data: payload,
            lockScreen: lockScreen
        });
    },
    buscarJustificativasInibirRestricoes() {
        return Http.get({
            url: URL_BASE + '/justificativas-inibicao',
            lockScreen: false
        });
    },
    inibirRestricao(payload) {
        return Http.post({
            url: URL_BASE + '/inibicao-restricao',
            data: payload,
            lockScreen: true
        });
    },
    editarRestricao(payload) {
        return Http.post({
            url: URL_BASE + '/inibicao-restricao/editar',
            data: payload,
            lockScreen: true
        });
    },
    buscarInibicaoRestricaoOperacao(payload) {
        return Http.post({
            url: URL_BASE + '/buscar/inibicao',
            data: payload,
            lockScreen: true
        });
    },
    buscarDadosInibicao(payload) {
        return Http.post({
            url: URL_BASE + '/buscar/inibicao/edicao',
            data: payload,
            lockScreen: true
        });
    },
    downloadPrimeiraAnalise(id) {
        const fileLink = document.createElement('a');
        try {
            return Http
                .get({
                    url: URL_BASE + `/${id}/download-primeira-analise`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t('mensagens.sistema.realizandoDownloadDaAnaliseSocioambiental')
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    }
};
